// extracted by mini-css-extract-plugin
module.exports =  {"author":"_7a3fb80146--author--Yueo2","avatar":"_7a3fb80146--avatar--JdESi","rating":"_7a3fb80146--rating--JHThb","stars":"_7a3fb80146--stars--zTjLF"};